/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './patient-identifier-type.reducer';

export const PatientIdentifierType = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const patientIdentifierTypeList = useAppSelector(state => state.patientIdentifierType.entities);
  const loading = useAppSelector(state => state.patientIdentifierType.loading);
  const totalItems = useAppSelector(state => state.patientIdentifierType.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="patient-identifier-type-heading" data-cy="PatientIdentifierTypeHeading">
        <Translate contentKey="tinyMedicRestApp.patientIdentifierType.home.title">Patient Identifier Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/patient-identifier-type/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.home.createLabel">Create new Patient Identifier Type</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.patientIdentifierType.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {patientIdentifierTypeList && patientIdentifierTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('uuid')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.uuid">Uuid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uuid')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('format')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.format">Format</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('format')} />
                </th>
                <th className="hand" onClick={sort('required')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.required">Required</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('required')} />
                </th>
                <th className="hand" onClick={sort('formatDescription')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.formatDescription">Format Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('formatDescription')} />
                </th>
                <th className="hand" onClick={sort('validator')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.validator">Validator</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('validator')} />
                </th>
                <th className="hand" onClick={sort('locationBehavior')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.locationBehavior">Location Behavior</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('locationBehavior')} />
                </th>
                <th className="hand" onClick={sort('uniquenessBehavior')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.uniquenessBehavior">Uniqueness Behavior</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uniquenessBehavior')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('prefix')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.prefix">Prefix</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prefix')} />
                </th>
                <th className="hand" onClick={sort('postFix')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.postFix">Post Fix</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('postFix')} />
                </th>
                <th className="hand" onClick={sort('prefixYearSno')}>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.prefixYearSno">Prefix Year Sno</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prefixYearSno')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.doctor">Doctor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.paramedic">Paramedic</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientIdentifierType.tenant">Tenant</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {patientIdentifierTypeList.map((patientIdentifierType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/patient-identifier-type/${patientIdentifierType.id}`} color="link" size="sm">
                      {patientIdentifierType.id}
                    </Button>
                  </td>
                  <td>{patientIdentifierType.name}</td>
                  <td>{patientIdentifierType.uuid}</td>
                  <td>{patientIdentifierType.description}</td>
                  <td>{patientIdentifierType.format}</td>
                  <td>{patientIdentifierType.required ? 'true' : 'false'}</td>
                  <td>{patientIdentifierType.formatDescription}</td>
                  <td>{patientIdentifierType.validator}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.LocationBehavior.${patientIdentifierType.locationBehavior}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.UniquenessBehavior.${patientIdentifierType.uniquenessBehavior}`} />
                  </td>
                  <td>{patientIdentifierType.microSec}</td>
                  <td>{patientIdentifierType.timestampentry}</td>
                  <td>{patientIdentifierType.lastupdated}</td>
                  <td>{patientIdentifierType.cursor}</td>
                  <td>{patientIdentifierType.active ? 'true' : 'false'}</td>
                  <td>{patientIdentifierType.prefix}</td>
                  <td>{patientIdentifierType.postFix}</td>
                  <td>{patientIdentifierType.prefixYearSno ? 'true' : 'false'}</td>
                  <td>
                    {patientIdentifierType.doctor ? (
                      <Link to={`/doctor/${patientIdentifierType.doctor.id}`}>{patientIdentifierType.doctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientIdentifierType.paramedic ? (
                      <Link to={`/paramedic/${patientIdentifierType.paramedic.id}`}>{patientIdentifierType.paramedic.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientIdentifierType.tenant ? (
                      <Link to={`/tenant/${patientIdentifierType.tenant.id}`}>{patientIdentifierType.tenant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/patient-identifier-type/${patientIdentifierType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/patient-identifier-type/${patientIdentifierType.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/patient-identifier-type/${patientIdentifierType.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.home.notFound">No Patient Identifier Types found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={patientIdentifierTypeList && patientIdentifierTypeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PatientIdentifierType;
